import React from "react";
import { UsersIcon } from "@heroicons/react/solid";
import { partners } from "../data";

export default function Partners() {
    return (
        <section id="partners">
        <div className="container px-5 py-10 mx-auto text-center">
          <UsersIcon className="w-16 inline-block mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font text-stone-900 mb-12">
            Partners
          </h1>
          <div className="flex flex-wrap m-4">
            {partners.map((partner) => (
              <div className="p-4 md:w-1/5 w-full">
                <div className="h-full bg-white bg-opacity-40 p-8 shadow-lg hover:drop-shadow-lg">
                  <div className="inline-flex items-center">
                    <img
                      alt={partner.name}
                      src={partner.image}
                      className="w-64 rounded flex-shrink-0 object-cover object-center"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        </section>
    )
}


// WEBPACK FOOTER //
// ./src/components/Partners.js